<template>
  <div class="job-filters">
    <filter-multiselect-list
      v-for="filterItem in config"
      :key="filterItem.type"
      :filterConfig="filterItem"
      :filterOptions="getMultiselectOptions(filterItem)"
      :activeFilters="jobsActiveFiltersState[filterItem.type] || []"
      :isDisable="isDisable[filterItem.type]"
      :placeholder="placeholder[filterItem.type]"
      @add-filter="addActiveFilter"
      @remove-filter="removeActiveFilter"
      @blur="updateJobs"
    >
    </filter-multiselect-list>
  </div>
</template>

<script>

import {debounce, find, identity, isEmpty, pickBy} from 'lodash';
import {mapGetters} from 'vuex';

import utils from '@/utils/utils';

import FilterMultiselectList from './FilterMultiselectList';
import filterConfig from './filter-config';

export default {
  data() {
    return {
      topOptionsAmount: 5
    };
  },
  computed: {
    ...mapGetters(['jobsOptionsState', 'jobsOptionsLoadingState', 'jobsActiveFiltersState']),
    config() {
      return filterConfig.availableFilters;
    },
    isDisable() {
      let disabled = {};
      for (let filterItem of this.config) {
        disabled[filterItem.type] = isEmpty(this.jobsOptionsState[filterItem.type]);
      }
      return disabled;
    },
    placeholder() {
      let placeholders = {};
      for (let filterItem of this.config) {
        placeholders[filterItem.type] = this.getPlaceholder(filterItem);
      }
      return placeholders;
    }
  },
  methods: {
    addActiveFilter(filterType, activeFilter) {
      if (!this.jobsFilterByValueExists(filterType, activeFilter.value)) {
        this.$store.commit('addJobsActiveFiltersState', {filterType, activeFilter});
      }
    },
    removeActiveFilter(filterType, activeFilter) {
      this.$store.commit('removeJobsActiveFiltersState', {filterType, activeFilter});
      const dependentFilters = this.getDependentFilterTypes(filterType);
      for (let type of dependentFilters) {
        this.$store.commit('removeJobsActiveFiltersState', {filterType: type});
      }
      this.updateJobs();
    },
    jobsFilterByValueExists(filterType, filterValue) {
      return Boolean(find(this.jobsActiveFiltersState[filterType], {value: filterValue}));
    },
    updateJobs: debounce(function() {
      let {search, source, utm_source, utm_medium, utm_campaign, utm_content} = this.$route.query;
      let filters = utils.getQueryParamsByFiltersState(this.jobsActiveFiltersState);
      let query = {search, source, utm_source, utm_medium, utm_campaign, utm_content, ...filters};
      this.$router.push({query: pickBy(query, identity)});
      this.$emit('after-update-filters');
    }, 300),
    getPlaceholder(filterItem) {
      if (this.isDisable[filterItem.type]) {
        return filterItem.dependency && isEmpty(this.jobsActiveFiltersState[filterItem.dependency])
          ? filterItem.dependencyPlaceholder
          : this.$gettext('Not found');
      }
      return filterItem.placeholder || this.$gettext('Any');
    },
    getDependentFilterTypes(filterType) {
      let res = [];
      for (let filterItem of this.config) {
        if (filterItem.dependency === filterType) {
          res.push(filterItem.type);
        }
      }
      return res;
    },
    getOptionsByType(type) {
      return this.jobsOptionsState[type] || [];
    },
    getMultiselectOptions({type, separateTopOptions}) {
      if (separateTopOptions) {
        return this.getOptionsWithSeparatedTopOnes(type);
      }
      return this.getOptionsByType(type);
    },
    getOptionsSortedByCount(type) {
      let options = [...this.getOptionsByType(type)];
      return options.sort((a, b) => b.count - a.count);
    },
    getOptionsWithSeparatedTopOnes(type) {
      let topOptions = this.getOptionsSortedByCount(type).slice(0, this.topOptionsAmount);
      let otherOptions = this.getOptionsByType(type).filter(location => !topOptions.includes(location));

      if (topOptions.length && otherOptions.length) {
        return [...topOptions, {isSeparator: true}, ...otherOptions];
      }

      return [...topOptions];
    }
  },
  components: {FilterMultiselectList}
};
</script>
